<template>
</template>

<script>    
import Vue from 'vue'

export default {    
    methods: {
        gotToTheCustomerPage() {
            this.$router.push('/customer/email/' + this.$route.params.email);
        },

        getOrderId() {
            Vue.api.get('zendesk/orders/latest?email=' + this.$route.params.email, {}, {
                callback: (response) => {
                    if(response && response.success && response.data.order_id) {
                        this.$router.push('/order/' + response.data.order_id);
                    }
                    else{
                        alert('Something went wrong. Try again.')
                    }
                },
                error: (err) => {
                    console.error("Error getting order id", err);
                },
                errorMessage: (message) => {
                    if(message === 'ORDER_NOT_FOUND') {
                        alert('Order not found.');
                        this.gotToTheCustomerPage();
                    }
                    else{
                        alert("Something went wrong: " + message + ". Try again.");
                    }
                },
            });
        },
    },
    created() {
        this.getOrderId();
    }
}
</script>